<script setup lang="ts">
import { RouterLink } from 'vue-router'
</script>

<template>
  <RouterLink
    to="/"
    class="back-button"
  >
    <span class="back-arrow">←</span>
    <span class="back-text">Main Menu</span>
  </RouterLink>
</template>

<style scoped>
.back-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  background: #fff;
  border: 3px solid #000;
  box-shadow: 3px 3px 0 #000;
  text-decoration: none;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.back-button:hover {
  transform: translate(-2px, -2px);
  box-shadow: 5px 5px 0 #000;
}

.back-button:active {
  transform: translate(1px, 1px);
  box-shadow: 1px 1px 0 #000;
}

.back-arrow {
  font-family: 'Mangati', 'Impact', 'Arial Black', sans-serif;
  font-size: 20px;
  color: #000;
  line-height: 1;
}

.back-text {
  font-family: 'Mangati', 'Impact', 'Arial Black', sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #000;
  text-transform: uppercase;
  letter-spacing: 1px;
  white-space: nowrap;
}
</style>
